import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { SmartRenderer } from '../component-interface';
import { pluck, toRaphaelColor, pluckNumber } from '../lib';
var MOTHER_OF_COLOR = '#eeeeee';

var ToolBar =
/*#__PURE__*/
function (_SmartRenderer) {
  _inherits(ToolBar, _SmartRenderer);

  function ToolBar(a) {
    var _this;

    _classCallCheck(this, ToolBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolBar).call(this, a)), _this.props = {};
    return _this;
  }

  _createClass(ToolBar, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = b.config,
          d = b.getFromEnv('chartConfig');
      b.__setDefaultConfig(), this.props.width = pluckNumber(a.width, 0), this.props.height = pluckNumber(a.height, 0), c.orientation = pluck(a.toolbarorientation, c.orientation), c.hPadding = pluck(a.toolbarhpadding, c.hPadding), c.vPadding = pluck(a.toolbarvpadding, c.vPadding), c.backgroundcolor = pluck(a.toolbarbackgroundcolor, c.backgroundcolor), c.backgroundalpha = pluck(a.toolbarbackgroundalpha, c.backgroundalpha), c.bordercolor = pluck(a.toolbarbordercolor, c.bordercolor), c.borderalpha = pluck(a.toolbarborderalpha, c.borderalpha), c.borderthickness = pluck(a.toolbarborderthickness, c.borderthickness), c.hDirection = pluckNumber(a.toolbarhdirection, 'r' === d.toolbarHAlign ? -1 : 1), c.vDirection = pluckNumber(a.toolbarvdirection, 'b' === d.toolbarBAlign ? -1 : 1), c.hAlign = pluck(a.hAlign, 'center').toLowerCase(), c.vAlign = pluck(a.vAlign, 'middle').toLowerCase(), c.marginTop = pluckNumber(a.marginTop, a.spacing, c.marginTop), c.marginLeft = pluckNumber(a.marginLeft, a.spacing, c.marginLeft), c.marginRight = pluckNumber(a.marginRight, a.spacing, c.marginRight), c.marginBottom = pluckNumber(a.marginBottom, a.spacing, c.marginBottom);
    }
  }, {
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      var a = this,
          b = a.config;
      b.orientation = 'horizontal', b.hPadding = 0, b.vPadding = 0, b.backgroundcolor = MOTHER_OF_COLOR, b.backgroundalpha = 0, b.bordercolor = MOTHER_OF_COLOR, b.borderalpha = 0, b.borderthickness = 1, b.spacing = 2.5, b.marginTop = 2.5, b.marginLeft = 2.5, b.marginRight = 2.5, b.marginBottom = 2.5;
    }
  }, {
    key: "getLogicalSpace",
    value: function getLogicalSpace() {
      var a = this,
          b = a.config,
          c = a.props,
          d = 0,
          e = 0;
      return a.getChildren('tool') && a.getChildren('tool').length && (a.getChildren('tool').forEach(function (a) {
        if (a.getState('visible') && !a.getState('removed')) {
          var _a$getLogicalSpace = a.getLogicalSpace(),
              _c = _a$getLogicalSpace.width,
              f = _a$getLogicalSpace.height,
              g = _a$getLogicalSpace.marginTop,
              h = _a$getLogicalSpace.marginLeft,
              i = _a$getLogicalSpace.marginRight,
              j = _a$getLogicalSpace.marginBottom;

          'horizontal' === b.orientation ? (void 0 !== _c && (d += _c + (i || 0) + (h || 0)), e < (f = f + (g || 0) + (j || 0)) && (e = f)) : (void 0 !== f && (e += f + (g || 0) + (j || 0)), d < (_c = _c + (i || 0) + (h || 0)) && (d = _c));
        }
      }), d += 2 * b.hPadding, e += 2 * b.vPadding, c.width = c.width > d ? c.width : d, c.height = c.height > e ? c.height : e), {
        width: d,
        height: e,
        marginTop: b.marginTop,
        marginLeft: b.marginLeft,
        marginRight: b.marginLeft,
        marginBottom: b.marginLeft
      };
    }
  }, {
    key: "manageSpace",
    value: function manageSpace() {
      var a,
          b = this,
          c = b.config,
          d = this.getChildren('tool') || [];

      for (var _d in a = 'horizontal' === c.orientation ? b._placeToolHorizontally() : b._placeToolVertically(), a) {
        a.hasOwnProperty(_d) && b.getChild(_d).setDimension(a[_d]);
      }

      d.forEach(function (a) {
        a.manageSpace && a.manageSpace();
      });
    }
  }, {
    key: "_placeToolHorizontally",
    value: function _placeToolHorizontally() {
      var a,
          b,
          c,
          d,
          e = this,
          f = e.config,
          g = e.props,
          h = f.hPadding,
          i = g.width - f.hPadding,
          j = {},
          k = {
        left: [],
        right: [],
        center: []
      },
          l = {
        left: 0,
        right: 0,
        center: 0
      };
      return e.getChildren('tool') && e.getChildren('tool').length && ((0 < f.hDirection ? e.getChildren('tool') : e.getChildren('tool').slice(0).reverse()).forEach(function (a) {
        if (a.getState('visible') && !a.getState('removed')) {
          var _a$getAlignment = a.getAlignment(),
              _b = _a$getAlignment.hAlign,
              _a$getLogicalSpace2 = a.getLogicalSpace(),
              _c2 = _a$getLogicalSpace2.width,
              _d2 = _a$getLogicalSpace2.height,
              _h = _a$getLogicalSpace2.marginTop,
              _i = _a$getLogicalSpace2.marginLeft,
              m = _a$getLogicalSpace2.marginRight,
              n = _a$getLogicalSpace2.marginBottom,
              o = a.getId();

          l[_b] += _c2 + (_i || 0) + (m || 0), k[_b].push(o), j[o] = {}, j[o].y = e.props.y + _h + f.vPadding + (g.height - 2 * f.vPadding - (_d2 + n + _h)) / 2;
        }
      }), k.left.forEach(function (a) {
        var _e$getChild$getLogica = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica.width,
            c = _e$getChild$getLogica.marginLeft,
            d = _e$getChild$getLogica.marginRight;

        h += c || 0, j[a].x = e.props.x + f.hPadding + h, h += b + (d || 0);
      }), k.right.reverse().forEach(function (a) {
        var _e$getChild$getLogica2 = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica2.width,
            c = _e$getChild$getLogica2.marginLeft,
            d = _e$getChild$getLogica2.marginRight;

        i -= b + (d || 0), j[a].x = e.props.x + f.hPadding + i, i -= c || 0;
      }), a = [l.left + f.hPadding, g.width - (l.right + f.hPadding)], b = Math.abs(a[0] - a[1]), c = a[0] + b / 2, d = c - l.center / 2, k.center.forEach(function (a) {
        var _e$getChild$getLogica3 = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica3.width,
            c = _e$getChild$getLogica3.marginLeft,
            g = _e$getChild$getLogica3.marginRight;

        d += c || 0, j[a].x = e.props.x + f.hPadding + d, d += b + g || 0;
      })), j;
    }
  }, {
    key: "getAlignment",
    value: function getAlignment() {
      return {
        hAlign: this.config.hAlign,
        vAlign: this.config.vAlign
      };
    }
  }, {
    key: "_placeToolVertically",
    value: function _placeToolVertically() {
      var a,
          b,
          c,
          d,
          e = this,
          f = e.config,
          g = e.props,
          h = f.vPadding,
          i = g.height - f.vPadding,
          j = {
        top: [],
        middle: [],
        bottom: []
      },
          k = {
        top: 0,
        middle: 0,
        bottom: 0
      },
          l = {};
      return e.getChildren('tool') && e.getChildren('tool').length && ((0 < f.vDirection ? e.getChildren('tool') : e.getChildren('tool').reverse()).forEach(function (a) {
        if (a.getState('visible') && !a.getState('removed')) {
          var _a$getAlignment2 = a.getAlignment(),
              _b2 = _a$getAlignment2.vAlign,
              _a$getLogicalSpace3 = a.getLogicalSpace(),
              _c3 = _a$getLogicalSpace3.width,
              _d3 = _a$getLogicalSpace3.height,
              _h2 = _a$getLogicalSpace3.marginTop,
              _i2 = _a$getLogicalSpace3.marginLeft,
              m = _a$getLogicalSpace3.marginRight,
              n = _a$getLogicalSpace3.marginBottom,
              o = a.getId();

          k[_b2] += _d3 + (_h2 || 0) + (n || 0), j[_b2].push(a.getId()), l[o] = {}, l[o].x = e.props.x + _i2 + f.hPadding + _i2 + (g.width - 2 * f.hPadding - (_c3 + _i2 + m)) / 2;
        }
      }), j.top.forEach(function (a) {
        var _e$getChild$getLogica4 = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica4.height,
            c = _e$getChild$getLogica4.marginTop,
            d = _e$getChild$getLogica4.marginBottom;

        h += c || 0, l[a].y = e.props.y + f.vPadding + h, h += b + (d || 0);
      }), j.bottom.reverse().forEach(function (a) {
        var _e$getChild$getLogica5 = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica5.height,
            c = _e$getChild$getLogica5.marginTop,
            d = _e$getChild$getLogica5.marginBottom;

        i -= b + (d || 0), l[a].y = e.props.y + f.vPadding + i, i -= c || 0;
      }), a = [k.top + f.vPadding, g.height - (k.bottom + f.vPadding)], b = Math.abs(a[0] - a[1]), c = a[0] + b / 2, d = c - k.middle / 2, j.middle.forEach(function (a) {
        var _e$getChild$getLogica6 = e.getChild(a).getLogicalSpace(),
            b = _e$getChild$getLogica6.height,
            c = _e$getChild$getLogica6.marginTop,
            g = _e$getChild$getLogica6.marginBottom;

        d += c || 0, l[a].y = e.props.y + f.vPadding + d, d += b + g || 0;
      })), l;
    }
  }, {
    key: "setDimension",
    value: function setDimension() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      a.x !== void 0 && (this.props.x = a.x), a.y !== void 0 && (this.props.y = a.y), a.width !== void 0 && (this.props.width = a.width), a.height !== void 0 && (this.props.height = a.height);
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this.props;
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this,
          b = a.config,
          c = a.getDimension();
      a.addGraphicalElement({
        id: 'group',
        el: 'group',
        attr: {
          name: 'toolbar'
        },
        container: {
          id: 'toolbar-master',
          isParent: !0
        },
        component: a,
        label: 'group'
      }), a.addGraphicalElement({
        id: 'carpet',
        el: 'rect',
        attr: Object.assign({
          fill: toRaphaelColor({
            color: b.backgroundcolor,
            alpha: b.backgroundalpha
          }),
          stroke: toRaphaelColor({
            color: b.bordercolor,
            alpha: b.borderalpha
          }),
          "stroke-width": b.borderthickness
        }, c),
        container: {
          label: 'group',
          id: 'group'
        },
        component: a,
        label: 'carpet'
      });
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'toolbar';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'Toolbar';
    }
  }]);

  return ToolBar;
}(SmartRenderer);

export default ToolBar;